import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';

import AdminTitleBar from 'Parts/common/AdminTitleBar';
import EventAdminConfigurationInformationForm from '../components/EventAdminConfigurationInformationFormContainer';
import EventAdminRelatedCampaigns from '../components/EventAdminRelatedCampaigns';
import EventAdminHistory from '../components/EventAdminHistory';
import ResponsiveTabs from 'Parts/ui/components/ResponsiveTabs';
// import Can from 'Parts/session/components/CanContainer';

// import { checkAuthorization } from 'Parts/common/authorizationUtils';

import eventAdminPage_en from './locales/EventAdminPage_en.json';
import eventAdminPage_fr from './locales/EventAdminPage_fr.json';

class EventAdminPage extends React.Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'EventAdminPage', eventAdminPage_en);
    i18next.addResourceBundle('fr', 'EventAdminPage', eventAdminPage_fr);
  }

  render() {
    const { t } = this.props;

    const tabPages = [
      {
        title: t('configuration-tab-title'),
        slug: 'configuration',
        container: () => <EventAdminConfigurationInformationForm {...this.props} />
      },
      // {
      //   title: t('related-campaigns-tab-title'),
      //   slug: 'related-campaigns',
      //   container: () => <EventAdminRelatedCampaigns {...this.props} />
      // },
      // {
      //   title: t('history-tab-title'),
      //   slug: 'history',
      //   container: () => <EventAdminHistory {...this.props} />
      // }
    ];

    return (
      <div className="EventAdminPage">
        <Helmet>
          <title>{t('events')}</title>
        </Helmet>
        <AdminTitleBar title={t('events')} />
        <ResponsiveTabs pages={tabPages} parentPage={this.props} defaultTabHasNoSlug />
      </div>
    );
  }
}

EventAdminPage.defaultProps = {
  permissions: {
    platform: {
      plugin: {
        event: null
      }
    }
  }
};

export default translate('EventAdminPage')(EventAdminPage);
